﻿export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const VALIDATE_FORM_BLOCK = 'VALIDATE_FORM_BLOCK';
export const REGISTER_FORM_BLOCK = 'REGISTER_FORM_BLOCK';
export const VALIDATE_PARTIAL_BLOCK = 'VALIDATE_PARTIAL_BLOCK';
export const REGISTER_PARTIAL_BLOCK = 'REGISTER_PARTIAL_BLOCK';
export const GET_DIVA_CONTRACTS = "GET_DIVA_CONTRACTS";
export const STORE_DIVA_CONTRACTS = "STORE_DIVA_CONTRACTS";
export const STORE_UPDATE_PORTING_DETAILS = "STORE_UPDATE_PORTING_DETAILS";
export const GET_UPDATE_PORTING_DETAILS = "GET_UPDATE_PORTING_DETAILS";
export const GET_SIGN_PORTINGS = "GET_SIGN_PORTINGS";
export const STORE_SIGN_PORTINGS = "STORE_SIGN_PORTINGS";
export const SHOW_CONTRACTS = "SHOW_CONTRACTS";
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const GET_NON_PORTING_CONTRACTS = "GET_NON_PORTING_CONTRACTS";
export const STORE_NON_PORTING_CONTRACTS = "STORE_NON_PORTING_CONTRACTS";
export const GET_NON_PORTING_CONTRACTS_BTC = "GET_NON_PORTING_CONTRACTS_BTC";
export const STORE_NON_PORTING_CONTRACTS_BTC = "STORE_NON_PORTING_CONTRACTS_BTC";
export const APPROVE_ORDER_BY_CUSTOMER = "APPROVE_ORDER_BY_CUSTOMER";
export const GET_PAGE_OVERVIEW = "GET_PAGE_OVERVIEW";
export const STORE_PAGE_OVERVIEW = "STORE_PAGE_OVERVIEW";
export const GET_APPROVE_ORDER_BY_CUSTOMER = "GET_APPROVE_ORDER_BY_CUSTOMER";
export const STORE_APPROVE_ORDER_BY_CUSTOMER = "STORE_APPROVE_ORDER_BY_CUSTOMER";
export const GET_APPROVE_ORDER_BY_CUSTOMER_BTC = "GET_APPROVE_ORDER_BY_CUSTOMER_BTC";
export const JUMP_NEXT_PAGE = "JUMP_NEXT_PAGE";
export const GET_CANCEL_ORDER = "GET_CANCEL_ORDER";
export const STORE_CANCEL_ORDER = "STORE_CANCEL_ORDER";
export const SIGN_DOCUMENTS_BTC = "SIGN_DOCUMENTS_BTC";
export const GET_UPLOAD_DOCUMENT = "GET_UPLOAD_DOCUMENT";
export const STORE_UPLOAD_DOCUMENT = "STORE_UPLOAD_DOCUMENT";
export const GET_DELIVERY_ADDRESS = "GET_DELIVERY_ADDRESS";
export const STORE_DELIVERY_ADDRESS = "STORE_DELIVERY_ADDRESS";
export const GET_CREDIT_CARD_RETURN_URL = "GET_CREDIT_CARD_RETURN_URL";
export const GET_INIT_PAYMENT_LOADER = "GET_INIT_PAYMENT_LOADER";
export const GET_REDIRECT_TO_URL = "GET_REDIRECT_TO_URL";